import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Stack,
  IconButton,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SelectAddressComponent } from 'src/hooks/useForm';
import { Close } from '@mui/icons-material';

const DialogChangeDestinationAddresses = ({
  open,
  onClose,
  onChange,
  value,
}) => {
  const { t } = useTranslation('translation');
  return (
    <Dialog maxWidth="md" fullWidth open={open} onClose={onClose}>
      <DialogTitle>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          gap={2}
        >
          <Typography variant="h6" fontWeight={600}>
            {t('donations.change-destination-addresses')}
          </Typography>

          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent
        sx={{
          mt: 1,
        }}
      >
        <SelectAddressComponent value={value} onChange={onChange} />
      </DialogContent>
    </Dialog>
  );
};

export default DialogChangeDestinationAddresses;
